import * as HalveTongbewegingen from "./halve_tongbewegingen";
import * as Materialen from "./materialen";
import * as NRGLassen from "./nrglassen";
import * as PuntEnKruisstukken from "./punt_en_kruisstukken";
import * as SmeerlozeConstructies from "./smeerloze_constructie";
import * as Strijkregels from "./strijkregels";
import * as Wisselstellers from "./wisselstellers";
import { memoize } from "oj-utils";
import { BoogStraal, HoekVerhouding, SpoorStaafProfiel, WisselLigger, WisselType } from "../configuration";
import * as Lookup from "./lookup";
import { questions } from "./questions";
import state from "../state";
import { getFullProduct, getProductDetails } from "../api";
export const WisselTypeToIdx = {
    "NORMAL_SWITCH:ANGLE=LEFT": [Lookup.wissel.indexOf("NORMAL_SWITCH"), Lookup.richting.indexOf("LEFT")],
    "NORMAL_SWITCH:ANGLE=RIGHT": [Lookup.wissel.indexOf("NORMAL_SWITCH"), Lookup.richting.indexOf("RIGHT")],
    "SYMMETRIC_SWITCH": [Lookup.wissel.indexOf("SYMMETRIC_SWITCH"), -1],
    "ENGLISH_SWITCH": [Lookup.wissel.indexOf("ENGLISH_SWITCH"), -1],
    "HALF_ENGLISH_SWITCH": [Lookup.wissel.indexOf("HALF_ENGLISH_SWITCH"), -1],
    "INTERSECTION_SWITCH": [Lookup.wissel.indexOf("INTERSECTION_SWITCH"), -1],
};
export const HoekVerhoudingIdx = {
    "1_9": Lookup.hoek.indexOf("1_9"),
    "1_15": Lookup.hoek.indexOf("1_15"),
    "1_4,5_2x1_9": Lookup.hoek.indexOf("1_4,5_2x1_9"),
    "1_12": Lookup.hoek.indexOf("1_12"),
};
export const SpoorStaafProfielIdx = {
    "54E1": Lookup.profiel.indexOf("54E1"),
    "54E5": Lookup.profiel.indexOf("54E5"),
    // "540": Lookup.profiel.indexOf("540"),
};
export const WisselLiggerIdx = {
    "CONCRETE": Lookup.wisselLigger.indexOf("CONCRETE"),
    "WOOD": Lookup.wisselLigger.indexOf("WOOD"),
};
export const BoogStraalIdx = {
    "195": Lookup.boogstraal.indexOf("195"),
    "725": Lookup.boogstraal.indexOf("725"),
    "390": Lookup.boogstraal.indexOf("390"),
    "204": Lookup.boogstraal.indexOf("204"),
    "260": Lookup.boogstraal.indexOf("260"),
    "400": Lookup.boogstraal.indexOf("400"),
    "465": Lookup.boogstraal.indexOf("465"),
    "1200": Lookup.boogstraal.indexOf("1200"),
    "600": Lookup.boogstraal.indexOf("600"),
};
export const _find = (data, wi, hi, li, pi, ri, bi) => {
    for (const x of data) {
        const [_key, _wissel, _hoek, _ligger, _profiel, _richting, _boogstraal] = x;
        if (wi !== -1 && _wissel !== -1 && _wissel !== wi)
            continue;
        if (hi !== -1 && _hoek !== -1 && _hoek !== hi)
            continue;
        if (li !== -1 && _ligger !== -1 && _ligger !== li)
            continue;
        if (pi !== -1 && _profiel !== -1 && _profiel !== pi)
            continue;
        if (ri !== -1 && _richting !== -1 && _richting !== ri)
            continue;
        if (bi !== -1 && _boogstraal !== -1 && _boogstraal !== bi)
            continue;
        return x;
    }
};
export const _filter = (data, wi, hi, li, pi, ri, bi) => {
    const result = [];
    for (const x of data) {
        const [_key, _wissel, _hoek, _ligger, _profiel, _richting, _boogstraal] = x;
        if (wi !== -1 && _wissel !== -1 && _wissel !== wi)
            continue;
        if (hi !== -1 && _hoek !== -1 && _hoek !== hi)
            continue;
        if (li !== -1 && _ligger !== -1 && _ligger !== li)
            continue;
        if (pi !== -1 && _profiel !== -1 && _profiel !== pi)
            continue;
        if (ri !== -1 && _richting !== -1 && _richting !== ri)
            continue;
        if (bi !== -1 && _boogstraal !== -1 && _boogstraal !== bi)
            continue;
        result.push(x);
    }
    return result;
};
export const transformFilterArgs = memoize((wissel, hoek, ligger, profiel, boogstraal) => {
    const [wisselIdx, richtingIdx] = wissel ? WisselTypeToIdx[wissel] : [-1, -1];
    if (wisselIdx == undefined || richtingIdx == undefined)
        throw new Error(`Invalid wissel type: ${wissel}`);
    const hoekIdx = hoek ? HoekVerhoudingIdx[hoek] : -1;
    if (hoekIdx == undefined)
        throw new Error(`Invalid hoek verhouding: ${hoek}`);
    const liggerIdx = ligger ? WisselLiggerIdx[ligger] : -1;
    if (liggerIdx == undefined)
        throw new Error(`Invalid ligger: ${ligger}`);
    const profielIdx = profiel ? SpoorStaafProfielIdx[profiel] : -1;
    if (profielIdx == undefined)
        throw new Error(`Invalid spoor staaf profiel: ${profiel}`);
    const boogstraalIdx = boogstraal ? BoogStraalIdx[boogstraal] : -1;
    if (boogstraalIdx == undefined)
        throw new Error(`Invalid boog straal: ${boogstraal}`);
    return [wisselIdx, hoekIdx, liggerIdx, profielIdx, richtingIdx, boogstraalIdx];
}, (...args) => args.join("|"));
export const hasResults = (wissel, hoek, ligger, profiel, boogstraal) => {
    const args = transformFilterArgs(wissel, hoek, ligger, profiel, boogstraal);
    if (_find(Materialen.MATERIALEN, ...args))
        return true;
    if (_find(HalveTongbewegingen.HALVE_TONGBEWEGINGEN, ...args))
        return true;
    if (_find(PuntEnKruisstukken.KRUISSTUKKEN, ...args))
        return true;
    if (_find(PuntEnKruisstukken.PUNTSTUKKEN, ...args))
        return true;
    if (_find(Strijkregels.STRIJKREGELS, ...args))
        return true;
    return false;
};
export const find = (artCodeTSNL, filtered, cat) => {
    if (cat) {
        const found = (filtered[cat] ?? []).find(x => x.artCodeTSNL === artCodeTSNL);
        return found ? { product: found, category: cat, list: filtered[cat] } : undefined;
    }
    for (const cat in filtered) {
        const found = (filtered[cat] ?? []).find(x => x.artCodeTSNL === artCodeTSNL);
        if (found)
            return { product: found, category: cat, list: filtered[cat] };
    }
};
export const filter = (wissel, hoek, ligger, profiel, boogstraal) => {
    const args = transformFilterArgs(wissel, hoek, ligger, profiel, boogstraal);
    const halveTongbewegingen = _filter(HalveTongbewegingen.HALVE_TONGBEWEGINGEN, ...args).map(HalveTongbewegingen.parse);
    const puntstukken = _filter(PuntEnKruisstukken.PUNTSTUKKEN, ...args).map(PuntEnKruisstukken.parse);
    const kruisstukken = _filter(PuntEnKruisstukken.KRUISSTUKKEN, ...args).map(PuntEnKruisstukken.parse);
    const strijkregels = _filter(Strijkregels.STRIJKREGELS, ...args).map(Strijkregels.parse);
    const bevestigingsmaterialen = _filter(Materialen.BEVESTIGINGS_MATERIALEN, ...args).map(row => Materialen.parse(row, "bevestigingsmaterialen"));
    const rugplatenEnStoelen = _filter(Materialen.RUGPLATEN_EN_STOELEN, ...args).map(row => Materialen.parse(row, "rugplatenEnStoelen"));
    const onderlegplaten = _filter(Materialen.ONDERLEGPLATEN, ...args).map(row => Materialen.parse(row, "onderlegplaten"));
    return {
        halveTongbewegingen,
        puntstukken,
        kruisstukken,
        strijkregels,
        bevestigingsmaterialen,
        rugplatenEnStoelen,
        onderlegplaten,
        wisselstellers: Wisselstellers.WISSELSTELLERS.map(Wisselstellers.parse),
        smeerlozeConstructies: SmeerlozeConstructies.SMEERLOZE_CONSTRUCTIES.map(SmeerlozeConstructies.parse),
        nrglassen: NRGLassen.NRG_LASSEN.map(NRGLassen.parse),
    };
};
export const getBaseProductList = (wissel, hoek, ligger, profiel, boogstraal) => {
    const args = transformFilterArgs(wissel, hoek, ligger, profiel, boogstraal);
    const halveTongbeweging = _find(HalveTongbewegingen.HALVE_TONGBEWEGINGEN, ...args);
    const halveTongbewegingNA = halveTongbeweging ? undefined : _find(HalveTongbewegingen.HALVE_TONGBEWEGINGEN, args[0], -1, -1, -1, args[4], -1);
    const puntstuk = _find(PuntEnKruisstukken.PUNTSTUKKEN, ...args);
    const puntstukNA = puntstuk ? undefined : _find(PuntEnKruisstukken.PUNTSTUKKEN, args[0], -1, -1, -1, args[4], -1);
    const kruisstuk = _find(PuntEnKruisstukken.KRUISSTUKKEN, ...args);
    const kruisstukNA = kruisstuk ? undefined : _find(PuntEnKruisstukken.KRUISSTUKKEN, args[0], -1, -1, -1, args[4], -1);
    const strijkregel = _find(Strijkregels.STRIJKREGELS, ...args);
    const strijkregelNA = strijkregel ? undefined : _find(Strijkregels.STRIJKREGELS, args[0], -1, -1, -1, args[4], -1);
    const wisselsteller = Wisselstellers.WISSELSTELLERS[0];
    const smeerlozeConstructie = SmeerlozeConstructies.SMEERLOZE_CONSTRUCTIES[0];
    const nrgLas = NRGLassen.NRG_LASSEN[0];
    return [
        halveTongbeweging
            ? {
                ...HalveTongbewegingen.parse(halveTongbeweging),
            }
            : halveTongbewegingNA
                ? {
                    fallback: true,
                    ...HalveTongbewegingen.parse(halveTongbewegingNA),
                }
                : undefined,
        puntstuk
            ? {
                ...PuntEnKruisstukken.parse(puntstuk),
            }
            : puntstukNA
                ? {
                    fallback: true,
                    ...PuntEnKruisstukken.parse(puntstukNA),
                }
                : undefined,
        kruisstuk
            ? {
                ...PuntEnKruisstukken.parse(kruisstuk),
            }
            : kruisstukNA
                ? {
                    fallback: true,
                    ...PuntEnKruisstukken.parse(kruisstukNA),
                }
                : undefined,
        strijkregel
            ? {
                ...Strijkregels.parse(strijkregel),
            }
            : strijkregelNA
                ? {
                    fallback: true,
                    ...Strijkregels.parse(strijkregelNA),
                }
                : undefined,
        wisselsteller
            ? {
                ...Wisselstellers.parse(wisselsteller),
            }
            : undefined,
        smeerlozeConstructie
            ? {
                ...SmeerlozeConstructies.parse(smeerlozeConstructie),
            }
            : undefined,
        nrgLas
            ? {
                ...NRGLassen.parse(nrgLas),
            }
            : undefined,
    ]
        .sort((a, b) => {
        const aFallback = (a && "fallback" in a) ? a.fallback : false;
        const bFallback = (b && "fallback" in b) ? b.fallback : false;
        if (aFallback && !bFallback)
            return 1;
        if (!aFallback && bFallback)
            return -1;
        return 0;
    });
};
export const _findByAnswers = (data, source, answers) => {
    const results = [];
    outer: for (const x of data) {
        for (const qi in answers) {
            const ai = answers[qi];
            const question = source[Number(qi)];
            const answer = question.options[ai];
            if (question != undefined && answer != undefined && x[question.key] != answer.value)
                continue outer;
        }
        results.push(x);
    }
    return results;
};
export const _findClosest = (data, variant) => {
    if (!variant)
        return;
    let best = undefined;
    let score = -1;
    for (const x of data) {
        let s = 0;
        for (const key in x)
            if (x[key] === variant[key])
                s++;
        if (s > score) {
            best = x;
            score = s;
        }
    }
    return best;
};
export const getCrosssell = (product, progress) => {
    const crosssell = [];
    if ("crosssell" in product && product.crosssell)
        crosssell.push(...product.crosssell);
    if ("onderlegSet" in product && product.onderlegSet)
        crosssell.push(product.onderlegSet);
    const products = [];
    for (const code of crosssell) {
        const mat = find(code, state.products.filtered)?.product;
        const item = {
            artCodeTSNL: code,
            ...(mat ?? {}),
            promise: (mat
                ? getFullProduct(mat)
                : getProductDetails(code))
                .catch(() => {
                // ignore errors, item will have only code as name and no price
            })
                .then(full => {
                if (full)
                    Object.assign(item, full);
                progress?.(item);
                return item;
            })
        };
        products.push(item);
    }
    return products;
};
export const getAllArticleCodes = () => {
    const base = [
        ...HalveTongbewegingen.HALVE_TONGBEWEGINGEN.map(HalveTongbewegingen.parse),
        ...PuntEnKruisstukken.PUNTSTUKKEN.map(PuntEnKruisstukken.parse),
        ...PuntEnKruisstukken.KRUISSTUKKEN.map(PuntEnKruisstukken.parse),
        ...Strijkregels.STRIJKREGELS.map(Strijkregels.parse),
        ...Materialen.BEVESTIGINGS_MATERIALEN.map(row => Materialen.parse(row, "bevestigingsmaterialen")),
        ...Materialen.RUGPLATEN_EN_STOELEN.map(row => Materialen.parse(row, "rugplatenEnStoelen")),
        ...Materialen.PLATEN_EN_STOELEN.map(row => Materialen.parse(row, "platenEnStoelen")),
        ...Materialen.ONDERLEGPLATEN.map(row => Materialen.parse(row, "onderlegplaten")),
        ...Wisselstellers.WISSELSTELLERS.map(Wisselstellers.parse),
        ...SmeerlozeConstructies.SMEERLOZE_CONSTRUCTIES.map(SmeerlozeConstructies.parse),
        ...NRGLassen.NRG_LASSEN.map(NRGLassen.parse),
    ];
    const articleCodes = new Set();
    for (const product of base) {
        articleCodes.add(product.artCodeTSNL);
        if ("crosssell" in product && product.crosssell)
            for (const code of product.crosssell)
                articleCodes.add(code);
        if ("onderlegSet" in product && product.onderlegSet)
            articleCodes.add(product.onderlegSet);
    }
    return articleCodes;
};
window["_getAllArticleCodes"] = getAllArticleCodes;
